import React from "react";
import { GoogleMap, LoadScript, DirectionsRenderer, Marker } from "@react-google-maps/api";
const containerStyle = {
    width: "100%",
    height: "100%",
    borderRadius: "10px",
};

const center = {
    lat: 33.738045,
    lng: 73.084488,
};
const GoogleMapComp = ({
    directions,
    mapLoading,
    startPosition,
    handleStartMarker,
    endPosition,
    handleEndMarker,
    userMarkers = [], // Array of user markers
}) => {
    console.log(userMarkers);
    return (
        <LoadScript googleMapsApiKey="AIzaSyAnbMv1DS7NNcrx-DaSX9MlfPtZFy68ELU" libraries={["places", "directions"]} onLoad={mapLoading}>
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={10}
                onLoad={mapLoading}
                options={{
                    mapTypeControl: false,
                    zoomControl: false,
                }}
            >
                {startPosition && (
                    <Marker
                        position={startPosition}
                        draggable={true}
                        // onPositionChanged={(event) => handleStartMarker(event, startPosition)}
                    />
                )}
                {endPosition && (
                    <Marker
                        position={endPosition}
                        draggable={true}
                        onDragEnd={handleEndMarker}
                        icon={{
                            url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
                        }}
                    />
                )}
                {userMarkers.map((marker, index) => (
                    <Marker
                        key={index}
                        position={marker.position}
                        icon={marker.icon} // Optional: Add custom marker icons for different users
                        title={marker.title} // Optional: Add a title for the marker
                    />
                ))}
                <DirectionsRenderer directions={directions} />
            </GoogleMap>
        </LoadScript>
    );
};

export default GoogleMapComp;
